var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"remove__list"},[_c('span',[_vm._v(" "+_vm._s(_vm.$t("list.messages.select_list_or_chat"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }